import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";

import Image from "next/image";
import { Box, Typography } from "@mui/material";
import { hindiTestimonials, testimonials } from "./cityData.js";

interface ProfessionalReviewProps {
  selected?: any;
}

const ProfessionalReview: React.FC<ProfessionalReviewProps> = ({
  selected,
}) => {
  const testimonial = selected ? testimonials : hindiTestimonials;

  return (
    <section
      style={{
        padding: "2rem 0",
        maxWidth: "min(92%, 1220px)",
        margin: "0 auto",
      }}
    >
      <Box sx={{ px: { xs: 2, sm: 3 } }}>
        <Typography
          variant="h4"
          component="h2"
          className="join-professional-steps"
          sx={{
            fontWeight: 700,
            padding: "1rem 0",
            fontSize: { xs: "1.35rem", sm: "1.75rem" },
            color: "#123524",
          }}
        >
          {selected ? (
            <>
              Our happy{" "}
              <Box component="span" sx={{ color: "#1f7a4d" }}>
                professionals
              </Box>
            </>
          ) : (
            <>
              हमारे खुश{" "}
              <Box component="span" sx={{ color: "#1f7a4d" }}>
                प्रोफेशनल
              </Box>
            </>
          )}
        </Typography>
      </Box>
      <Swiper
        grabCursor
        centeredSlides
        slidesPerView="auto"
        loop
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        pagination={{ clickable: true }}
        breakpoints={{
          140: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
        }}
        modules={[Autoplay, Pagination]}
        style={{ padding: "20px 16px 2.5rem" }}
      >
        {testimonial.map((testimonial: any, index: any) => (
          <SwiperSlide
            key={index}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
              padding: "16px",
              background: "#fff",
              borderRadius: "14px",
              border: "1px solid rgba(18, 53, 36, 0.1)",
              boxShadow: "0 8px 24px rgba(18, 53, 36, 0.1)",
              minHeight: "16rem",
              height: "16rem",
            }}
          >
            <Image
              src={testimonial.img}
              alt={`testimonial-${index}`}
              height={1000}
              width={1000}
              style={{
                width: "100px",
                height: "100px",
                borderRadius: "50%",
                marginBottom: "20px",
              }}
            />
            <Typography
              variant="body1"
              color="text.secondary"
              style={{
                fontStyle: "italic",
                marginBottom: "10px",
                fontSize: "14px",
              }}
            >
              &#34;{testimonial.text}&#34;
            </Typography>
            <h6
              style={{
                fontWeight: "bold",
                color: "#1f7a4d",
                position: "absolute",
                bottom: "16px",
              }}
            >
              {testimonial.author}
            </h6>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default ProfessionalReview;
